import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../utils';

const initialState = {
  permissions: null,
  error: null,
  loading: false,
};

const getPermissionsStart = (state, action) => {
  return updateObject(state, {
    permissions: null,
    error: null,
    loading: true,
  });
};

const getPermissionsSuccess = (state, action) => {
  return updateObject(state, {
    permissions: action.data,
    error: null,
    loading: false,
  });
};

const getPermissionsFail = (state, action) => {
  return updateObject(state, {
    permissions: null,
    error: action.error,
    loading: false,
  });
};

const hasAccessToInfusionSoftStart = (state, action) => {
  return updateObject(state, {
    hasAccessToInfusionSoft: null,
    hasAccessToInfusionSoftError: null,
    hasAccessToInfusionSoftLoading: true,
  });
};

const hasAccessToInfusionSoftSuccess = (state, action) => {
  return updateObject(state, {
    hasAccessToInfusionSoft: action.data,
    hasAccessToInfusionSoftError: null,
    hasAccessToInfusionSoftLoading: false,
  });
};

const hasAccessToInfusionSoftFail = (state, action) => {
  return updateObject(state, {
    hasAccessToInfusionSoft: null,
    hasAccessToInfusionSoftError: action.error,
    hasAccessToInfusionSoftLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PERMISSIONS_START:
      return getPermissionsStart(state, action);
    case actionTypes.GET_PERMISSIONS_SUCCESS:
      return getPermissionsSuccess(state, action);
    case actionTypes.GET_PERMISSIONS_FAIL:
      return getPermissionsFail(state, action);

    case actionTypes.HAS_ACCESS_TO_INFUSION_SOFT_START:
      return hasAccessToInfusionSoftStart(state, action);
    case actionTypes.HAS_ACCESS_TO_INFUSION_SOFT_SUCCESS:
      return hasAccessToInfusionSoftSuccess(state, action);
    case actionTypes.HAS_ACCESS_TO_INFUSION_SOFT_FAIL:
      return hasAccessToInfusionSoftFail(state, action);

    default:
      return state;
  }
};

export default reducer;
